export const DEFAULT_WATERMARK_SIZE_PX = 126;
export const DEFAULT_WATERMARK_MARGIN_DISTANCE_PX = 22;
